import { styled } from "@mui/material/styles";

const Container = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  textAlign: "center",
  padding: "65px",
  width: "90%",
  background: "#F3F3F3",
}));

export { Container };
